<template>
  <BTab @click="handleTabChange">
    <template #title>
      <div class="mb-0">
        {{ __('Outras configurações') }}
      </div>
    </template>
    <div class="d-flex flex-column">
      <h2 class="font-semibold fs-6 lh-24 mb-2 fw-semibold font-dark">{{ __('Data de estagnação') }}</h2>
      <p class="form-text my-0 d-flex flex-column flex-start lh-18 fs-8 mb-3-5 fw-normal font-dark">
        {{ __('Defina a data de estagnação do seu cartão de negócio.') }}<br>
        {{ __('Informe a data limite para permanência do negócio no estágio do funil de vendas para configurar a data de estagnação') }}
      </p>
    </div>
    <div class="mb-3-5">
      <div class="col-12 px-0">
        <BFormSelect v-model="stagnationDateOption" :options="stagnationDateOptions" :placeholder="__('Selecione')" class="bg-white py-2-5 pl-3 pr-2-5 select-border text-grey fw-regular font-montserrat radius-8 blue-shadow">
          <template #first>
            <BFormSelectOption v-if="isLoading" :value="null" disabled>
              <span>
                {{ __('Carregando...') }}         
              </span>
              <BSpinner
                small
                class="spinner"
              />
            </BFormSelectOption>
            <BFormSelectOption :value="null" disabled>{{ __('Selecione') }}</BFormSelectOption>
          </template>
        </BFormSelect>
      </div>
    </div>
    <div class="d-flex flex-column lh-10 fs-9 gap-1 fw-normal mb-3 font-dark">
      <p> 
        <strong>{{ __("Aqui estão alguns exemplos típicos de períodos limites que podem ser utilizados:") }}</strong> <br>
      </p>  
      <p>
        <strong>{{ __("3 dias:") }}</strong>&nbsp;{{ __("Para negócios que avançam rapidamente, um limite de 3 dias pode ser apropriado.") }} <br>
      </p>
      <p>
        <strong>{{ __("7 dias:") }}</strong>&nbsp;{{ __("Para negócios que não avançam rapidamente ou em vendas de curto ciclo, um limite de uma semana pode ser apropriado.") }} <br>
      </p>
      <p>
        <strong>{{ __("15 dias:") }}</strong>&nbsp;{{ __("Um período um pouco mais longo pode ser usado para negócios que geralmente têm ciclos de venda mais extensos.") }} <br>
      </p>
      <p>
        <strong>{{ __("30 dias:") }}</strong>&nbsp;{{ __("É comum em setores com ciclos de vendas mais longos ou para permitir mais tempo antes de considerar um negócio como estagnado.") }}<br>
      </p>
      <p>
        <strong>{{ __("60 dias:") }}</strong>&nbsp;{{ __("Usado para ciclos de venda muito longos ou para dar mais tempo antes de considerar um negócio como estagnado.") }}
      </p>
    </div>
    <button class="btn btn-primary ml-auto py-2-3 fs-7 salesflow-btn-secondary ml-0 mr-auto min-w-115" @click.prevent="saveStagnationDateOption()">
      {{ __('Salvar') }}
    </button>
  </BTab>
</template>


<script>
import { BTab, VBTooltip, BFormSelect, BFormSelectOption, BSpinner } from 'bootstrap-vue';

export default {
  components: {
    BTab,
    BFormSelect,
    BFormSelectOption,
    BSpinner
  },

  directives: {
    'b-tooltip': VBTooltip,
  },

  async mounted() {
    this.isLoading = true;
    await this.getStagnationDateOptions();
    this.isLoading = false;
    console.log('SalesFunnelOtherSettings');
  },

  data() {
    return {
      isLoading: false,
      stagnationDateOptions: [],
      stagnationDateOption: null,
    };
  },

  methods: {
    handleTabChange() {
      console.log('handleTabChange', 1);
      Bus.$emit('tab-changed', 1);
    },

    async getStagnationDateOptions() {
      this.$http.get('/settings/parameter/DateWhenDealStagnates')
        .then((response) => {
          this.stagnationDateOptions = response.data.options;
          this.stagnationDateOption = response.data.parameter;
        });
    },

    async saveStagnationDateOption() {
      this.$http.put('/settings/DateWhenDealStagnates', {value: this.stagnationDateOption})
        .then((response) => {
          console.log('response', response);
          if (response.data?.message) {
            // this.$toast.success(response.data.message);
            Alert.success(response.data.message);
          } else {
            this.$toast.error(response.data.message);
          }
        }).catch((error) => {
          this.$toast.error(error.response.data.message);
        });
    }
  },
};
</script>


<style scoped ::v-deep>
  .btn-cancel {
    font-size: 11px;
  }

  .break-text {
    word-wrap: break-word;
    word-break: break-word;
    white-space: normal;
  }

  .text-transform-none {
    text-transform: none !important;
  }

  .fs-6 {
    font-size: 16px !important;
  }

  .fs-7 {
    font-size: 14px !important;
  }

  .fs-8 {
    font-size: 12px !important;
  }

  .fs-9 {
    font-size: 10px !important;
  }

  .lh-24 {
    line-height: 24px !important;
  }

  .lh-18 {
    line-height: 18px !important;
  }

  .lh-10 {
    line-height: 10px !important;
  }

  .font-montserrat {
    font-family: 'Montserrat' !important;
  }
  
  .fw-normal {
    font-weight: 400 !important;
  }

  .fw-regular {
    font-weight: 500 !important;
  }

  .fw-semibold {
    font-weight: 600 !important;
  }

  .mb-3-5 {
    margin-bottom: 20px !important;
  }

  .pr-2-5 {
    padding-right: 12px !important;
  }

  .py-2-5 {
    padding-top: 12px !important;
    padding-bottom: 12px !important;
  }

  .py-2-3 {
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }

  .select-border {
    border: 1px solid #D1D1D1 !important;
  }

  .text-grey {
    color: #71767D !important;
  }

  .blue-shadow {
    box-shadow: 0 0 10px 0 #0d6efd19 !important;
  }

  .mb-4-5 {
    margin-bottom: 32px !important;
  }

  .radius-8 {
    border-radius: 8px !important;
  }

  .select-border:focus,
  .select-border.show {
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25) !important;
    outline: 0 !important;
  }

  .font-dark {
    color: #242424 !important;
  }

  .ml-0 {
    margin-left: 0 !important;
  }

  .min-w-115 {
    min-width: 115px !important;
  }
</style>

